import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CustomSelect from './CustomSelect/CustomSelect';
import { getCitiesAction } from '../store/location/asyncActions';

const CitySelect = ({ state, value, onChange, error, helperText, disabled, required, user, ...props }) => {
    const dispatch = useDispatch();
    const { cities } = useSelector((state) => state.location);

    useEffect(() => {
        if (state?.state_id && !cities.loading) {
            dispatch(getCitiesAction({ ...user, state_id: state.state_id }));
        }
    }, [dispatch, state]);

    return (
        <CustomSelect
            title="Select City"
            options={cities.data?.data || []}
            labelKey="city_name"
            value={value}
            onSelect={onChange}
            error={error}
            helperText={helperText}
            disabled={disabled || !state || cities.loading}
            required={required}
            {...props}
        />
    );
};

export default CitySelect;
